export const deliveryCategory = "Delivery";
export const deliveryDuringLockdownCategory = "Cuarentena";

export function getProviders() {
  return new Promise(function (resolve, reject) {
    var cached = getCache();
    if (cached) {
      console.debug("Cached providers");
      resolve(cached);
      return;
    }
    console.debug("Retrieving providers");
    fetch(
      "https://firebasestorage.googleapis.com/v0/b/cerdos-trufas.appspot.com/o/data.json?alt=media&token=53206100-f42a-4819-9f2f-db38563e7887"
    )
      .then(response => {
        console.debug("Retrieved providers");
        return response.json();
      })
      .then(providers => {
        providers.forEach(provider => {
          provider.categories = provider.categories || [];
          if (provider.deliveryDuringLockdown) {
            provider.categories.push(deliveryDuringLockdownCategory);
          } else if (provider.delivery) {
            provider.categories.push(deliveryCategory);
          }

          provider.categories = provider.categories.map(v => v.toLowerCase());
        });
        setCache(providers);
        resolve(providers);
      });
  });
}

export function getProvider(id) {
  console.debug("getProvider: ", id);
  return getProviders().then(ps => ps.find(p => p.id === id));
}

var __cache;
function setCache(providers) {
  __cache = providers;
}

function getCache() {
  return __cache;
}
